
(function () {
  "use strict";

  const PARAM = "bro_src";
  const STORAGE_KEY = "brotege_bro_src";
  const ATTRIBUTE_KEY = "bro_src";

  const ALLOWED = new Set([
    "bar_sub25",
    "popup_sub25",
    "cart_upsell",
    "hero_main"
  ]);

  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  let queue = Promise.resolve();
  let latestSource = null;

  function isAllowed(source) {
    return typeof source === "string" &&
      ALLOWED.has(source);
  }

  function storeSource(source) {
    latestSource = source;

    try {
      sessionStorage.setItem(STORAGE_KEY, source);
    } catch (error) {
      console.warn(
        "Brotege: Source storage unavailable",
        error
      );
    }
  }

  function getStoredSource() {
    if (latestSource) return latestSource;

    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);

      return isAllowed(stored) ? stored : null;
    } catch (error) {
      return null;
    }
  }

  async function saveSource(source) {
    const response = await fetch(
      root + "cart/update.js",
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            [ATTRIBUTE_KEY]: source
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        "Cart attribute update failed: " +
        response.status
      );
    }

    const cart = await response.json();

    if (
      cart.attributes?.[ATTRIBUTE_KEY] !== source
    ) {
      throw new Error(
        "Cart attribute not confirmed"
      );
    }

    console.log(
      "✅ Brotege tracking saved:",
      source
    );

    return cart;
  }

  function track(source) {
    if (!isAllowed(source)) {
      console.warn(
        "Brotege: Unapproved source:",
        source
      );

      return Promise.resolve(null);
    }

    storeSource(source);

    const task = queue.then(function () {
      return saveSource(source);
    });

    queue = task.catch(function (error) {
      console.warn(
        "Brotege source tracking:",
        error
      );
    });

    return task;
  }

  function getSource() {
    return getStoredSource();
  }

  // Shared tracking API for theme components.
  window.BrotegeSourceTracking = {
    track: track,
    getSource: getSource
  };

  // Capture approved source parameters on landing.
  const url = new URL(window.location.href);
  const incoming = url.searchParams.get(PARAM);

  if (isAllowed(incoming)) {
    track(incoming).catch(function () {
      // Error already logged by tracking queue.
    });
  }

  // Optional CTA integration for cart-drawer buttons
  // carrying data-bro-src. Track on successful action
  // through the shared API whenever possible.
})();
